import api from '@/api/leaderboard';

const getCurrentLeaderboard = context => new Promise(((resolve, reject) => {
  api.fetchCurrent()
    .then((response) => {
      context.commit('SET_CURRENT', response);
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      reject(error);
    });
}));

const getTransactions = context => new Promise(((resolve, reject) => {
  api.fetchTransactions()
    .then((response) => {
      context.commit('SET_TRANSACTIONS', response);
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      reject(error);
    });
}));


export default {
  getCurrentLeaderboard,
  getTransactions,
};

